import axios from 'axios';
import store from './../store/store'

// const baseUrl = 'https://kzxneih9q6.execute-api.eu-central-1.amazonaws.com/dev' // Mine
const baseUrl = 'https://oh8urq0oj1.execute-api.eu-central-1.amazonaws.com/dev' // Sandbox

export default {
  getWeek (weekId) {
    if (weekId) {
      console.log('api.getWeek weekId:', weekId);
      const url = `${baseUrl}/weeks/${weekId}`
      const headers = {
        Authorization: store.state.Auth.idToken,
        'Content-Type': 'application/json'
      }
      console.dir(store.state);
      return axios.get(url, { headers: headers });
    } else {
      return new Promise.reject('getWeek: weekId undefined');
    }
  },
  postBooking (booking) {
    const url = `${baseUrl}/bookings`;
    const headers = {
      Authorization: store.state.Auth.idToken,
      'Content-Type': 'application/json'
    }
    return axios.post(url, booking, { headers: headers });
  },
  deleteBooking (booking) {
    const url = `${baseUrl}/bookings`;
    const headers = {
      Authorization: store.state.Auth.idToken,
      'Content-Type': 'application/json'
    }
    const config = {
      params: { id: booking.id, date: booking.date },
      headers: headers
    };
    return axios.delete(url, config);
  },
  getRooms () {
    const url = `${baseUrl}/rooms`;
    const headers = {
      Authorization: store.state.Auth.idToken,
      'Content-Type': 'application/json'
    }
    return axios.get(url, { headers: headers });
  },
  generateCodes (params) {
    const amount = params.amount;
    const permissions = params.permissions;
    console.log('generateCodes', {amount, permissions});
    const url = `${baseUrl}/admin/generate-codes`;
    const headers = {
      Authorization: store.state.Auth.idToken,
      'Content-Type': 'application/json'
    }
    return axios.post(url, {amount, permissions}, { headers })
  },
  codeUsed (code) {
    const url = `${baseUrl}/register/remove-code`;
    const headers = {
      Authorization: store.state.Auth.idToken,
      'Content-Type': 'application/json'
    }
    const config = {
      params: { code },
      headers: headers
    };
    return axios.delete(url, config);
  }
}



// WEBPACK FOOTER //
// ./src/utils/api.js